


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { IMessage } from '@/store/alert/types';
import { LoginState, User } from '@/store/login/types';
import Alert from '@/components/Alert.vue';
import Cards from '@/components/Cards.vue';
import Input from '@/components/Input.vue';
import PasswordHelper from '@/helpers/PasswordHelper';

const namespace: string = 'login';

@Component({
  components: {
    Alert,
    Cards,
    Input,
  },
})
export default class AdminActivate extends Vue {
  @Action('createPassword', { namespace }) private createPassword: (
    user: User,
  ) => Promise<undefined>;
  @Action('getActivation', { namespace }) private getActivation: (
    activateCode: string,
  ) => void;
  @Mutation('alert/SHOW') private alert: (alertMessage: IMessage) => void;
  @State('login') private loginState?: LoginState;
  private user: any = {
    newPassword: '',
    confirmPassword: '',
  };
  @Prop(String) private _token: string;

  private onPassword(oldPassword: string, newPassword: string) {
    if (this.user.newPassword! !== '' && this.user.confirmPassword! !== '') {
      if (this.user.newPassword! === this.user.confirmPassword!) {
        if (PasswordHelper.isPasswordSecure(this.user.newPassword)) {
          let user = {
            activateCode: this._token,
            password: this.user.confirmPassword,
          };
          this.createPassword(user)
            .then(() => {
              this.user.newPassword = '';
              this.user.confirmPassword = '';
            })
            .catch(() => {});
        } else {
          this.alert({
            prefix: 'INPUT_',
            error: 'NOT_SECURE',
          });
        }
      } else {
        this.alert({
          prefix: 'INPUT_',
          error: 'NOT_SAME',
        });
      }
    } else {
      this.alert({
        prefix: 'INPUT_',
        error: 'EMPTY',
      });
    }
  }
}
